import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Form, Row, Select } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;
const { Option } = Select;

class CardAdvSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      typeList: [
        { value: 'all', name: '全部' },
        { value: '0', name: '绩效考核' },
        { value: '1', name: '政府申报' },
        { value: '2', name: '日常任务' },
      ],
      roleList: [
        { value: 'all', name: '全部' },
        { value: 'EXECUTIVE', name: '执行人' },
        { value: 'ASSISTANT', name: '协助者' },
      ],
      fettleList: [
        { value: 'all', name: '全部' },
        { value: '1', name: '未完成' },
        { value: '2', name: '已完成' },
        { value: '3', name: '已废弃' },
      ],
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      data: JSON.parse(JSON.stringify(data)),
    });
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        data: JSON.parse(JSON.stringify(nextProps.data)),
      });
    }
  }

  changeItem = (itemName, value) => {
    const { data } = this.state;
    switch (itemName) {
      case 'projectName':
        data.projectName = value.target.value;
        break;
      case 'type':
        data.type = value;
        break;
      case 'role':
        data.role = value;
        break;
      case 'projectUuid':
        data.projectUuid = value;
        break;
      case 'tag':
        data.tag = value;
        break;
      case 'endDate':
        data.endDate = value ? value.valueOf() : '';
        break;
      case 'fettle':
        data.fettle = value;
        break;
      default:
        break;
    }
    this.setState({ data });
  };

  handleOk = () => {
    const { data } = this.state;
    const newData = JSON.parse(JSON.stringify(data));
    Object.keys(newData).forEach(key => {
      if (newData[key] === 'all') {
        newData[key] = '';
      }
    });
    this.props.handleOk(newData);
  };

  resetParams = () => {
    this.setState({
      data: {},
    });
  };

  render() {
    const { data, typeList, roleList, fettleList } = this.state;
    const { tagList, projectList } = this.props;
    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 19 },
    };
    return (
      <Card style={this.props.style}>
        <Form>
          <Row>
            <Col span={8}>
              <FormItem {...ItemLayout} label="任务分类">
                <Select value={data.type} onChange={() => this.changeItem('type')}>
                  {typeList.map(item => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>

            <Col span={8}>
              <FormItem {...ItemLayout} label="任务状态">
                <Select value={data.fettle} onChange={() => this.changeItem('fettle')}>
                  {fettleList.map(item => {
                    return (
                      <Option value={item.value} key={item.value}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>

            <Col span={8}>
              <FormItem {...ItemLayout} label="任务标签">
                <Select value={data.tag} onChange={() => this.changeItem('tag')}>
                  {tagList.map(item => {
                    return (
                      <Option key={item.uuid} value={item.uuid}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <FormItem {...ItemLayout} label="我的角色">
                <Select value={data.role} onChange={() => this.changeItem('role')}>
                  {roleList.map(item => {
                    return (
                      <Option key={item.value} value={item.value}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>

            <Col span={8}>
              <FormItem {...ItemLayout} label="归属项目">
                <Select value={data.projectUuid} onChange={() => this.changeItem('projectUuid')}>
                  {projectList.map(item => {
                    return (
                      <Option key={item.uuid} value={item.uuid}>
                        {item.name}
                      </Option>
                    );
                  })}
                </Select>
              </FormItem>
            </Col>

            <Col span={8}>
              <FormItem {...ItemLayout} label="截至时间">
                {data.endDate ? (
                  <DatePicker
                    style={{ width: '100%' }}
                    value={moment(data.endDate)}
                    onChange={() => this.changeItem('endDate')}
                  />
                ) : (
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={() => this.changeItem('endDate')}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={this.handleOk} type="primary">
              确定
            </Button>
            <Button onClick={this.resetParams} style={{ marginLeft: '10px' }}>
              重置
            </Button>
          </Row>
        </Form>
      </Card>
    );
  }
}

export default Form.create()(CardAdvSearch);



// WEBPACK FOOTER //
// ./src/components/task/spTask/CardAdvFinSearch.js